import styles from "../../styles/modules/Terms.module.css";

export const Privacy = () => {
    return (
        <main className="content-area__main terms">
            <h1>개인정보 처리방침</h1>
            <p>
                <a href="/">디지털 길잡이</a>는 「개인정보 보호법」 제30조에
                따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고
                원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보
                처리방침을 수립·공개합니다.
            </p>
            <p>○ 이 개인정보 처리방침은 2023년 8월 18부터 적용됩니다.</p>
            <ol className={styles.listTerms}>
                <li>
                    <h2 className={styles.heading}>개인정보의 처리 목적</h2>
                    <p>
                        <a href="/">디지털 길잡이</a>는 다음의 목적을 위하여
                        개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의
                        목적 이외의 용도로는 이용되지 않으며 이용 목적이
                        변경되는 경우에는 「개인정보 보호법」 제18조에 따라
                        별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
                    </p>
                    <ol>
                        <li>
                            홈페이지 회원가입 및 관리
                            <p>
                                회원 가입의사 확인, 회원제 서비스 제공에 따른
                                본인 식별·인증, 회원자격 유지·관리, 서비스
                                부정이용 방지 목적으로 개인정보를 처리합니다.
                            </p>
                        </li>

                        <li>
                            재화 또는 서비스 제공
                            <p>
                                서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공을
                                목적으로 개인정보를 처리합니다.
                            </p>
                        </li>
                    </ol>
                </li>
                <li>
                    <h2 className={styles.heading}>
                        개인정보의 처리 및 보유 기간
                    </h2>
                    <ol className={styles.listCircledDecimal}>
                        <li>
                            디지털 길잡이는 법령에 따른 개인정보 보유·이용 기간
                            또는 정보주체로부터 개인정보를 수집할 때 동의받은
                            개인정보 보유·이용 기간 내에서 개인정보를
                            처리·보유합니다.
                        </li>
                        <li>
                            각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
                            <ul>
                                <li>
                                    홈페이지 회원가입 및 관리
                                    <p>
                                        홈페이지 회원가입 및 관리와 관련한
                                        개인정보는 수집·이용에 관한 동의일로부터
                                        회원 탈퇴 시까지 위 이용목적을 위하여
                                        보유·이용됩니다.
                                    </p>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li>
                    <h2 className={styles.heading}>처리하는 개인정보의 항목</h2>
                    <ol className={styles.listCircledDecimal}>
                        <li>
                            디지털 길잡이는 다음의 개인정보 항목을 처리하고
                            있습니다.
                            <ul>
                                <li>
                                    홈페이지 회원가입 및 관리
                                    <p>
                                        필수항목: 로그인 ID, 비밀번호, 접속 IP
                                        정보, 접속 로그, 서비스 이용 기록
                                    </p>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li>
                    <h2 className={styles.heading}>
                        개인정보의 파기 절차 및 파기 방법
                    </h2>
                    <ol className={styles.listCircledDecimal}>
                        <li>
                            디지털 길잡이는 개인정보 보유기간의 경과, 처리목적
                            달성 등 개인정보가 불필요하게 되었을 때는 지체없이
                            해당 개인정보를 파기합니다.
                        </li>
                        <li>
                            정보주체로부터 동의받은 개인정보 보유기간이
                            경과하거나 처리목적이 달성되었음에도 불구하고 다른
                            법령에 따라 개인정보를 계속 보존하여야 하는
                            경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로
                            옮기거나 보관장소를 달리하여 보존합니다.
                        </li>
                        <li>
                            개인정보 파기의 절차 및 방법은 다음과 같습니다.
                            <ol>
                                <li>
                                    파기 절차
                                    <p>
                                        디지털 길잡이는 파기 사유가 발생한
                                        개인정보를 선정하고, 디지털 길잡이의
                                        개인정보 보호 책임자의 승인을 받아
                                        개인정보를 파기합니다.
                                    </p>
                                </li>
                                <li>
                                    파기 방법
                                    <p>
                                        종이에 출력된 개인정보는 분쇄기로
                                        분쇄하거나 소각을 통하여 파기합니다.
                                        전자적 파일 형태의 정보는 기록을 재생할
                                        수 없는 기술적 방법을 사용합니다.
                                    </p>
                                </li>
                            </ol>
                        </li>
                    </ol>
                </li>
                <li>
                    <h2 className={styles.heading}>
                        정보주체와 법정대리인의 권리·의무 및 그 행사 방법에 관한
                        사항
                    </h2>
                    <ol className={styles.listCircledDecimal}>
                        <li>
                            정보주체는 디지털 길잡이에 대해 언제든지 개인정보
                            열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수
                            있습니다.
                        </li>

                        <li>
                            제1항에 따른 권리 행사는 디지털 길잡이에 대해
                            「개인정보 보호법」 시행령 제41조제1항에 따라 서면,
                            전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며
                            디지털 길잡이는 이에 대해 지체 없이 조치하겠습니다.
                        </li>

                        <li>
                            제1항에 따른 권리 행사는 정보주체의 법정대리인이나
                            위임을 받은 자 등 대리인을 통하여 하실 수 있습니다.
                            이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)”
                            별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
                        </li>

                        <li>
                            개인정보 열람 및 처리정지 요구는 「개인정보 보호법」
                            제35조 제4항, 제37조 제2항에 의하여 정보주체의
                            권리가 제한될 수 있습니다.
                        </li>

                        <li>
                            개인정보의 정정 및 삭제 요구는 다른 법령에서 그
                            개인정보가 수집 대상으로 명시되어 있는 경우에는 그
                            삭제를 요구할 수 없습니다.
                        </li>

                        <li>
                            디지털 길잡이는 정보주체 권리에 따른 열람의 요구,
                            정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를
                            한 자가 본인이거나 정당한 대리인인지를 확인합니다.
                        </li>
                    </ol>
                </li>
                <li>
                    <h2 className={styles.heading}>
                        개인정보의 안전성 확보 조치에 관한 사항
                    </h2>
                    <ol>
                        <li>
                            개인정보에 대한 접근 제한 개인정보를 처리하는
                            데이터베이스시스템에 대한 접근권한의 부여, 변경,
                            말소를 통하여 개인정보에 대한 접근통제를 위하여
                            필요한 조치를 하고 있으며 침입 차단 시스템을
                            이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
                        </li>

                        <li>
                            접속기록의 보관 및 위변조 방지 개인정보 처리시스템에
                            접속한 기록을 최소 1년 이상 보관, 관리하고 있으며,
                            다만 5만 명 이상의 정보주체에 관하여 개인정보를
                            추가하거나, 고유식별정보 또는 민감정보를 처리하는
                            경우에는 2년 이상 보관, 관리하고 있습니다. 또한,
                            접속기록이 위변조 및 도난, 분실되지 않도록 보안
                            기능을 사용하고 있습니다.
                        </li>

                        <li>
                            개인정보의 암호화 이용자의 개인정보는 비밀번호는
                            암호화 되어 저장 및 관리되고 있어, 본인만이 알 수
                            있으며 중요한 데이터는 파일 및 전송 데이터를
                            암호화하거나 파일 잠금 기능을 사용하는 등의 별도
                            보안 기능을 사용하고 있습니다.
                        </li>

                        <li>
                            해킹 등에 대비한 기술적 대책 디지털 길잡이는
                            해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및
                            훼손을 막기 위하여 보안프로그램을 설치하고 주기적인
                            갱신·점검을 하며 외부로부터 접근이 통제된 구역에
                            시스템을 설치하고 기술적/물리적으로 감시 및 차단하고
                            있습니다.
                        </li>
                    </ol>
                </li>
                <li>
                    <h2 className={styles.heading}>
                        개인정보를 자동으로 수집하는 장치의 설치·운영 및 그
                        거부에 관한 사항
                    </h2>
                    디지털 길잡이는 정보주체의 이용정보를 저장하고 수시로
                    불러오는 ‘쿠키(cookie)’를 사용하지 않습니다.
                </li>
                <li>
                    <h2 className={styles.heading}>
                        행태정보의 수집·이용·제공 및 거부 등에 관한 사항
                    </h2>
                    디지털 길잡이는 온라인 맞춤형 광고 등을 위한 행태정보를
                    수집·이용·제공하지 않습니다.
                </li>
                <li>
                    <h2 className={styles.heading}>
                        개인정보 보호 책임자에 관한 사항
                    </h2>
                    <ol className={styles.listCircledDecimal}>
                        <li>
                            디지털 길잡이는 개인정보 처리에 관한 업무를 총괄해서
                            책임지고, 개인정보 처리와 관련한 정보주체의 불만
                            처리 및 피해구제 등을 위하여 개인정보 보호 책임자를
                            지정하고 있습니다.
                        </li>
                        <li>
                            정보주체께서는 디지털 길잡이의 서비스를 이용하시면서
                            발생한 모든 개인정보 보호 관련 문의, 불만 처리,
                            피해구제 등에 관한 사항을 개인정보 보호 책임자 및
                            담당 부서로 문의하실 수 있습니다. 디지털 길잡이는
                            정보주체의 문의에 대해 지체 없이 답변 및 처리해 드릴
                            것입니다.
                        </li>
                        <ul>
                            <li>
                                개인정보 보호 책임자
                                <ul>
                                    <li>디지털 길잡이 담당자</li>
                                    <li>
                                        연락처:{" "}
                                        <a href="tel:+821000000000">
                                            +821000000000
                                        </a>
                                        ,{" "}
                                        <a href="mailto:id@domain">id@domain</a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                개인정보 보호 담당 부서
                                <ul>
                                    <li>
                                        부서명: 디지털 길잡이 개인정보보호 담당
                                        부서
                                    </li>
                                    <li>
                                        담당자: 디지털 길잡이 개인정보보호
                                        담당자
                                    </li>
                                    <li>
                                        연락처:{" "}
                                        <a href="tel:+821000000000">
                                            +821000000000
                                        </a>
                                        ,{" "}
                                        <a href="mailto:id@domain">id@domain</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </ol>
                </li>
                <li>
                    <h2 className={styles.heading}>
                        정보주체의 권익침해에 대한 구제 방법
                    </h2>
                    정보주체는 개인정보 침해로 인한 구제를 받기 위하여
                    개인정보분쟁조정위원회, 한국인터넷진흥원
                    개인정보침해신고센터 등에 분쟁 해결이나 상담 등을 신청할 수
                    있습니다. 이 밖에 기타 개인정보 침해의 신고, 상담에 대해서는
                    아래의 기관에 문의하시기를 바랍니다.
                    <ol>
                        <li>
                            개인정보분쟁조정위원회: (국번 없이) 1833-6972 (
                            <a href="https://www.kopico.go.kr/">
                                www.kopico.go.kr
                            </a>
                            )
                        </li>
                        <li>
                            개인정보침해신고센터: (국번 없이) 118 (
                            <a href="https://privacy.kisa.or.kr/">
                                privacy.kisa.or.kr
                            </a>
                            )
                        </li>
                        <li>
                            대검찰청: (국번 없이) 1301 (
                            <a href="https://www.spo.go.kr/">www.spo.go.kr</a>)
                        </li>
                        <li>
                            경찰청: (국번 없이) 182 (
                            <a href="https://ecrm.police.go.kr/">
                                ecrm.cyber.go.kr
                            </a>
                            )
                        </li>
                    </ol>
                    <p>
                        「개인정보보호법」제35조(개인정보의 열람),
                        제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지
                        등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한
                        처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은
                        자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수
                        있습니다.
                    </p>
                    <p>
                        ※ 행정심판에 대해 자세한 사항은 중앙행정심판위원회(
                        <a href="https://www.simpan.go.kr/">www.simpan.go.kr</a>
                        ) 홈페이지를 참고하시기를 바랍니다.
                    </p>
                </li>
                <li>
                    <h2 className={styles.heading}>개인정보 처리방침 변경</h2>
                    <ol className={styles.listCircledDecimal}>
                        <li>
                            이 개인정보 처리방침은 2023년 8월 18부터 적용됩니다.
                        </li>
                        <li>
                            이전의 개인정보 처리방침은 아래에서 확인하실 수
                            있습니다.
                            <ul>
                                <li>(없음)</li>
                            </ul>
                        </li>
                    </ol>
                </li>
            </ol>
        </main>
    );
};
